export class DateRange {
	from?: Date;
	to?: Date;
	constructor(init?: DateRange) {
		Object.assign(this, init);
	}
}
